import { Action } from 'redux';
import {
    GET_PROMOCODE_REQUEST,
    GET_PROMOCODE_RESPONSE,
    GET_PROMOCODE_ERROR,
    GET_PCR_CLINICS_REQUEST,
    GET_PCR_CLINICS_RESPONSE,
    GET_PCR_CLINICS_ERROR, CLEAR_PROMOCODE
} from '../../actions/Promocodes/promocodes';
import { PCRClinic, Promocode } from '../../models/Promocodes/promocodes';

export interface PromocodesState {
    promocodes: Promocode[] | null;
    pcrClinics: Array<PCRClinic>;
    loading: boolean;
    error: string;
}

const initialState: PromocodesState = {
    promocodes: null,
    pcrClinics: [],
    loading: false,
    error: ''
};

export const promocodesState = (state: PromocodesState = initialState, action: Action): PromocodesState => {
    switch (action.type) {
        case GET_PROMOCODE_REQUEST: {
            return {
                ...state,
                promocodes: initialState.promocodes,
                loading: true,
                error: initialState.error
            };
        }
        case GET_PROMOCODE_RESPONSE: {
            const promocodes = (action as any).response.result;
            return {
                ...state,
                promocodes,
                loading: initialState.loading
            };
        }
        case GET_PROMOCODE_ERROR: {
            console.error((action as any).error);
            return {
                ...state,
                loading: initialState.loading,
                error: (action as any).error.status.toString()
            };
        }
        case GET_PCR_CLINICS_REQUEST: {
            return {
                ...state,
                pcrClinics: initialState.pcrClinics,
                loading: true,
                error: initialState.error
            };
        }
        case GET_PCR_CLINICS_RESPONSE: {
            const pcrClinics = (action as any).response.result;
            return {
                ...state,
                pcrClinics,
                loading: initialState.loading
            };
        }
        case GET_PCR_CLINICS_ERROR: {
            console.error((action as any).error);
            return {
                ...state,
                loading: initialState.loading,
                error: (action as any).error.status.toString()
            };
        }
        case CLEAR_PROMOCODE: {
            return {
                ...state,
                promocodes: initialState.promocodes
            };
        }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Promocodes/promocodes.ts